export enum IncentiveFamily {
  RDTAX = 'rdtax',
  IPTAX = 'iptax'
}
